module.exports = __webpack_public_path__ + "img/rs.437d8503.svg";